import React from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { SparklesIcon, ExpandIcon, PlayCircleIcon, CheckIcon, MapPinIcon, ImageIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useViewMode } from '../../context/ViewModeContext';
export function DealerCreativeDashboard() {
  const navigate = useNavigate();
  const {
    viewMode,
    currentLocation
  } = useViewMode();
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2437">
      <Sidebar data-id="element-2438" />
      <main className="flex-1" data-id="element-2439">
        <Header data-id="element-2440" />
        <div className="px-6 py-8" data-id="element-2441">
          <div className="max-w-6xl mx-auto" data-id="element-2442">
            <div className="flex items-center justify-between mb-2" data-id="element-2443">
              <h1 className="text-2xl font-semibold text-gray-800" data-id="element-2444">
                Creative Customizer
              </h1>
              {viewMode === 'store' && currentLocation && <span className="inline-flex items-center px-3 py-1.5 bg-emerald-50 text-emerald-700 rounded-lg text-sm font-medium border border-emerald-200" data-id="element-2445">
                  <MapPinIcon size={14} className="mr-1.5" data-id="element-2446" />
                  {currentLocation.name}
                </span>}
            </div>
            <p className="text-gray-600 mb-8" data-id="element-2447">
              {viewMode === 'store' ? 'Localize brand creatives and generate AI-powered content for your dealership' : 'Create professional, brand-compliant creatives in minutes'}
            </p>

            <div className={`grid ${viewMode === 'store' ? 'grid-cols-4' : 'grid-cols-3'} gap-6`} data-id="element-2448">
              {/* Localization Tool - Only for Store View */}
              {viewMode === 'store' && <div className="bg-white rounded-lg border-2 border-emerald-200 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-2449">
                  <div className="absolute top-0 right-0 px-3 py-1 bg-emerald-500 text-white text-xs font-semibold rounded-bl-lg" data-id="element-2450">
                    STORE TOOL
                  </div>
                  <div className="p-6" data-id="element-2451">
                    <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6" data-id="element-2452">
                      <ImageIcon className="text-emerald-600" size={32} data-id="element-2453" />
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-2454">
                      Localize Creative
                    </h2>
                    <p className="text-gray-600 mb-6 text-sm" data-id="element-2455">
                      Add your dealership details to brand-approved creatives
                    </p>

                    <div className="space-y-3 mb-6" data-id="element-2456">
                      <div className="flex items-start text-sm text-gray-700" data-id="element-2457">
                        <CheckIcon size={16} className="text-emerald-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2458" />
                        <span data-id="element-2459">Add dealer name & logo</span>
                      </div>
                      <div className="flex items-start text-sm text-gray-700" data-id="element-2460">
                        <CheckIcon size={16} className="text-emerald-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2461" />
                        <span data-id="element-2462">Include address & contact</span>
                      </div>
                      <div className="flex items-start text-sm text-gray-700" data-id="element-2463">
                        <CheckIcon size={16} className="text-emerald-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2464" />
                        <span data-id="element-2465">Local offers & pricing</span>
                      </div>
                      <div className="flex items-start text-sm text-gray-700" data-id="element-2466">
                        <CheckIcon size={16} className="text-emerald-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2467" />
                        <span data-id="element-2468">Regional language support</span>
                      </div>
                    </div>

                    <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3 mb-6" data-id="element-2469">
                      <p className="text-xs text-emerald-800" data-id="element-2470">
                        <strong data-id="element-2471">Output:</strong> Localized image with dealer
                        info
                      </p>
                    </div>

                    <button onClick={() => navigate('/dealerization/step-1')} className="w-full bg-emerald-500 text-white px-6 py-3 rounded-md font-medium hover:bg-emerald-600 transition-colors" data-id="element-2472">
                      Start Localizing
                    </button>
                  </div>
                </div>}

              {/* AI Creative Generator */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2473">
                <div className="p-6" data-id="element-2474">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6" data-id="element-2475">
                    <SparklesIcon className="text-blue-600" size={32} data-id="element-2476" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-2477">
                    AI Creative Generator
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-2478">
                    {viewMode === 'store' ? 'Generate AI creatives following brand guidelines' : 'Create brand-compliant creatives from scratch with AI-powered image generation'}
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-2479">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2480">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2481" />
                      <span data-id="element-2482">Generate static images</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2483">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2484" />
                      <span data-id="element-2485">Multiple format outputs (1:1, 9:16, 16:9)</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2486">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2487" />
                      <span data-id="element-2488">AI-powered backgrounds</span>
                    </div>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6" data-id="element-2489">
                    <p className="text-xs text-blue-800" data-id="element-2490">
                      <strong data-id="element-2491">Output:</strong> Image and/or Video
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/ai-generator/step-1')} className="w-full bg-blue-500 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-600 transition-colors" data-id="element-2492">
                    Start Creating
                  </button>
                </div>
              </div>

              {/* Creative Resizer */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2493">
                <div className="p-6" data-id="element-2494">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6" data-id="element-2495">
                    <ExpandIcon className="text-purple-600" size={32} data-id="element-2496" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-2497">
                    Creative Resizer
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-2498">
                    Adapt existing creatives to different platform formats with
                    AI-powered resizing
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-2499">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2500">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2501" />
                      <span data-id="element-2502">Smart crop with focal point</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2503">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2504" />
                      <span data-id="element-2505">Intelligent expansion</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2506">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2507" />
                      <span data-id="element-2508">Multiple formats instantly</span>
                    </div>
                  </div>

                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mb-6" data-id="element-2509">
                    <p className="text-xs text-purple-800" data-id="element-2510">
                      <strong data-id="element-2511">Output:</strong> Multiple format versions
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/resizer/step-1')} className="w-full bg-purple-500 text-white px-6 py-3 rounded-md font-medium hover:bg-purple-600 transition-colors" data-id="element-2512">
                    Resize Creative
                  </button>
                </div>
              </div>

              {/* Image to Video Generator */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2513">
                <div className="p-6" data-id="element-2514">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-2515">
                    <PlayCircleIcon className="text-green-600" size={32} data-id="element-2516" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-2517">
                    Image to Video
                  </h2>
                  <p className="text-gray-600 mb-6 text-sm" data-id="element-2518">
                    Transform static product images into professional video ads
                    with AI-powered motion
                  </p>

                  <div className="space-y-3 mb-6" data-id="element-2519">
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2520">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2521" />
                      <span data-id="element-2522">Convert to 4-8 second videos</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2523">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2524" />
                      <span data-id="element-2525">AI-powered motion effects</span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700" data-id="element-2526">
                      <CheckIcon size={16} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-2527" />
                      <span data-id="element-2528">Maintains product design</span>
                    </div>
                  </div>

                  <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-6" data-id="element-2529">
                    <p className="text-xs text-green-800" data-id="element-2530">
                      <strong data-id="element-2531">Output:</strong> Professional video ad
                    </p>
                  </div>

                  <button onClick={() => navigate('/dealer/video-generator/upload')} className="w-full bg-green-500 text-white px-6 py-3 rounded-md font-medium hover:bg-green-600 transition-colors" data-id="element-2532">
                    Generate Video
                  </button>
                </div>
              </div>
            </div>

            {/* Benefits Section */}
            <div className="mt-12 bg-white rounded-lg border border-gray-200 p-8" data-id="element-2533">
              <h3 className="text-lg font-semibold text-gray-800 mb-6 text-center" data-id="element-2534">
                {viewMode === 'store' ? 'Why Use Creative Customizer?' : 'Why Use Creative Customizer?'}
              </h3>
              <div className="grid grid-cols-3 gap-8" data-id="element-2535">
                <div className="text-center" data-id="element-2536">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2537">
                    <CheckIcon className="text-blue-600" size={24} data-id="element-2538" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-2539">
                    Brand Compliant
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2540">
                    All creatives follow approved brand guidelines automatically
                  </p>
                </div>
                <div className="text-center" data-id="element-2541">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2542">
                    <SparklesIcon className="text-purple-600" size={24} data-id="element-2543" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-2544">
                    Zero Design Skills
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2545">
                    Pre-set templates and animations make it easy for anyone
                  </p>
                </div>
                <div className="text-center" data-id="element-2546">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2547">
                    <PlayCircleIcon className="text-green-600" size={24} data-id="element-2548" />
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2" data-id="element-2549">
                    Professional Quality
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2550">
                    Ad-like motion and transitions in minutes, not days
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}